import React from 'react';
import '../../App.css';
import HeroSection from '../assetsEnglish/HeroSection';
import Footer from '../assetsEnglish/Footer';

function Home() {
  return (
    <>
      <HeroSection />
      <Footer />
    </>
  );
  }

export default Home;
